import { memo } from "react";

import { LocalizedLink } from "@/components";
import Trans from "@/components/Trans/Trans";
import { ROUTES } from "@/constants";

const LINK_CLASS = "text-sm opacity-60 hover:opacity-100 transition-opacity";

function MinimalFooter() {
  return (
    <footer
      className="flex items-center justify-center gap-6 border-t border-gray-200 bg-white px-4 py-4 dark:border-gray-800 dark:bg-gradient-to-b dark:from-blue-1 dark:to-black"
      data-testid="MinimalFooter"
    >
      <LocalizedLink className={LINK_CLASS} to={ROUTES.privacy} target="_blank" aria-label="privacy">
        <Trans i18nKey="appFooter:resources.privacy" />
      </LocalizedLink>
      <LocalizedLink className={LINK_CLASS} to={ROUTES.terms} target="_blank" aria-label="terms">
        <Trans i18nKey="appFooter:resources.terms" />
      </LocalizedLink>
      <LocalizedLink className={LINK_CLASS} to={ROUTES.refund} target="_blank" aria-label="refund">
        <Trans i18nKey="appFooter:resources.refund" />
      </LocalizedLink>
    </footer>
  );
}

export default memo(MinimalFooter);
